






































import {Component, Prop, Vue} from "vue-property-decorator";
import { Action } from "vuex-class";
import moment from "moment";
import { NotificationMessage } from "@/modules/NotificationMessage";
import {Location} from "vue-router";
import FileRepository, { Document } from "@/repositories/FileRepository";

@Component({})
export default class Message extends Vue {
  protected loading: boolean = false;
  @Prop() protected message!: NotificationMessage;

  @Action("markNotificationMessageAsRead") protected markNotificationMessageAsRead!: (uuid: string) => Promise<void>;
  @Action("deleteNotificationMessage") protected deleteNotificationMessage!: (uuid: string) => Promise<void>;

  protected goTo(url: string | null): void {
    if (!url) {
      return;
    }
    this.loading = true;
    this.markAsRead();
    this.$emit("goto");
    if (this.isInternalUrl(url)) {
      const route = this.retrieveRouteFromUrl(url);
      this.$router.push(route).catch(() => undefined);
    } else {
      window.open(url, "_blank");
    }
  }

  protected download() {
    if (!this.message.link || !this.message.body) {
      return;
    }

    const doc = {
      uuid: "",
      link: this.message.link,
      clientOriginalFileName: this.message.body,
      type: "",
    };

    FileRepository.download(doc);
    this.markAsRead();
  }

  protected markAsRead(): void {
    this.loading = true;
    this.markNotificationMessageAsRead(this.message.uuid).then(() => {
      this.loading = false;
    });
  }

  protected deleteMessage(): void {
    this.loading = true;
    this.deleteNotificationMessage(this.message.uuid).then(() => {
      this.loading = false;
    });
  }

  protected isInternalUrl(url: string): boolean {
    return url.startsWith(window.location.origin);
  }

  protected retrieveRouteFromUrl(url: string): Location {
    const parsedUrl = new URL(url);
    const resolvedRoute = this.$router.resolve(parsedUrl.pathname + parsedUrl.search);

    return {
      name: resolvedRoute.route.name,
      params: resolvedRoute.route.params,
      query: resolvedRoute.route.query,
      hash: parsedUrl.hash,
    };
  }

  protected get timeAgo(): string {
    return moment(this.message.createdAt).fromNow();
  }

  protected get displayableDate(): string {
    return moment(this.message.createdAt).format("DD/MM/YYYY HH:mm");

  }

  protected get messageClass(): object {
    return {
      "notification-message": true,
      "notification-message--unread": !this.message.seenAt,
    };
  }
}
